import TableComponent, { IColumnProps } from '../../components/TableComponent';
import React, { useContext, useEffect, useState } from 'react';
import { LockReset, Route, Shield, Webhook, Mail } from '@mui/icons-material';
import { Badge as MuiBadge } from '@mui/material';
import ButtonComponent from '../../components/ButtonComponent';
import { useGetAllIntegrationsByLicenseAsync } from '../../services/IntegrationService/hooks/useMutation';
import IntegrationEditModal from './_components/IntegrationEditModal';
import ButtonActionsComponent from '../../components/ButtonActionsComponent';
import ConfirmDeleteModalComponent from '../../components/ConfirmDeleteModalComponent';
import {
  IIntegrationProps,
  IntegrationDiscriminator,
} from '../../services/IntegrationService/types';
import { AppContext } from '../../context/AppContextProvider';
import IconImageComponent from '../../components/IconImageComponent';
import cigam_icon from '../../assets/images/icons/devices/cigam_icon.png';
import moni_icon from '../../assets/images/icons/devices/moni_icon.png';
import sigma_icon from '../../assets/images/icons/devices/sigma_icon.png';
import tuya_icon from '../../assets/images/icons/devices/tuya_icon.png';
import totvs_icon from '../../assets/images/icons/devices/totvs_icon.png';
import { useDeleteSurgardIntegrationAsync } from '../../services/IntegrationService/SurgardService/hooks/useMutation';
import { useDeleteWebhookIntegrationAsync } from '../../services/IntegrationService/WebhookService/hooks/useMutation';
import { useDeleteMoniIntegrationAsync } from '../../services/IntegrationService/MoniService/hooks/useMutation';
import { useDeleteDefenseIntegration } from '../../services/IntegrationService/DefenseService/hooks/useMutations';
import { useDeleteSigmaIntegrationAsync } from '../../services/IntegrationService/SigmaService/hooks/useMutation';
import { useDeleteDefenseBridgeAsync } from '../../services/Defense/Bridge/hooks/useMutations';
import HeaderDashboard from 'pages/DashboardPageClient/_components/_ui/Header';
import { t } from 'i18next';
import { useDeleteClassAppIntegrationAsync } from '../../services/IntegrationService/ClassAppService/hooks/useMutation';
import { useDeleteGvdasaIntegrationAsync } from '../../services/IntegrationService/GvdasaService/hooks/useMutation';
import { useDeleteActiveSoftIntegrationAsync } from '../../services/IntegrationService/ActiveSoftService/hooks/useMutation';
import { useDeleteSmtpIntegrationAsync } from '../../services/IntegrationService/SmtpService/hooks/useMutation';
import { useDeleteClipEscolaIntegrationAsync } from '../../services/IntegrationService/ClipEscolaService/hooks/useMutation';
import { useDeleteSophiaIntegrationAsync } from '../../services/IntegrationService/SophiaService/hooks/useMutation';
import { useDeleteCigamIntegrationAsync } from 'services/IntegrationService/CigamService/hooks/useMutation';
import { useDeleteTuyaIntegrationAsync } from 'services/IntegrationService/TuyaService/hooks/useMutation';
import { useDeleteTotvsIntegrationAsync } from 'services/IntegrationService/TotvsService/hooks/useMutation';
import { useDeleteTotvsIENHIntegrationAsync } from '../../services/IntegrationService/TotvsIENHService/hooks/useMutation';

function IntegrationPage() {
  const { showSnackbar } = useContext(AppContext);
  const [integrations, setIntegrations] = useState<IIntegrationProps[]>([]);
  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState<boolean>(false);
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);
  const [integrationEditModalKey, setIntegrationEditModalKey] = useState(0);
  const [selectedItem, setSelectedItem] = useState<IIntegrationProps>();

  const { mutateAsync: mutateGetAllIntegrationsByLicenseAsync } =
    useGetAllIntegrationsByLicenseAsync();
  const {
    mutateAsync: mutateDeleteSurgardIntegrationAsync,
    isLoading: isLoadingDeleteSurgardIntegrationAsync,
  } = useDeleteSurgardIntegrationAsync();
  const {
    mutateAsync: mutateDeleteWebhookIntegrationAsync,
    isLoading: isLoadingDeleteWebhookIntegrationAsync,
  } = useDeleteWebhookIntegrationAsync();
  const {
    mutateAsync: mutateDeleteMoniIntegrationAsync,
    isLoading: isLoadingDeleteMoniIntegrationAsync,
  } = useDeleteMoniIntegrationAsync();
  const {
    mutateAsync: mutateDeleteDefenseIntegrationAsync,
    isLoading: isLoadingDeleteDefenseIntegrationAsync,
  } = useDeleteDefenseIntegration();
  const {
    mutateAsync: mutateDeleteSigmaIntegrationAsync,
    isLoading: isLoadingDeleteSigmaIntegrationAsync,
  } = useDeleteSigmaIntegrationAsync();
  const {
    mutateAsync: mutateDeleteDefenseBridgeIntegrationAsync,
    isLoading: isLoadingDeleteDefenseBridgeIntegrationAsync,
  } = useDeleteDefenseBridgeAsync();
  const {
    mutateAsync: mutateDeleteClassAppIntegrationAsync,
    isLoading: isLoadingDeleteClassAppIntegrationAsync,
  } = useDeleteClassAppIntegrationAsync();
  const {
    mutateAsync: mutateDeleteTotvsIENHIntegrationAsync,
    isLoading: isLoadingDeleteTotvsIENHIntegrationAsync,
  } = useDeleteTotvsIENHIntegrationAsync();
  const {
    mutateAsync: mutateDeleteGvdasaIntegrationAsync,
    isLoading: isLoadingDeleteGvdasaIntegrationAsync,
  } = useDeleteGvdasaIntegrationAsync();
  const {
    mutateAsync: mutateDeleteActiveSoftIntegrationAsync,
    isLoading: isLoadingDeleteActiveSoftIntegrationAsync,
  } = useDeleteActiveSoftIntegrationAsync();
  const {
    mutateAsync: mutateDeleteSmtpIntegrationAsync,
    isLoading: isLoadingDeleteSmtpIntegrationAsync,
  } = useDeleteSmtpIntegrationAsync();
  const {
    mutateAsync: mutateDeleteClipEscolaIntegrationAsync,
    isLoading: isLoadingDeleteClipEscolaIntegrationAsync,
  } = useDeleteClipEscolaIntegrationAsync();
  const {
    mutateAsync: mutateDeleteSophiaIntegrationAsync,
    isLoading: isLoadingDeleteSophiaIntegrationAsync,
  } = useDeleteSophiaIntegrationAsync()
  const {
    mutateAsync: mutateDeleteCigamIntegrationAsync,
    isLoading: isLoadingDeleteCigamIntegrationAsync,
  } = useDeleteCigamIntegrationAsync()
  const {
    mutateAsync: mutateDeleteTuyaIntegrationAsync,
    isLoading: isLoadingDeleteTuyaIntegrationAsync,
  } = useDeleteTuyaIntegrationAsync()
  const {
    mutateAsync: mutateDeleteTotvsIntegrationAsync,
    isLoading: isLoadingDeleteTotvsIntegrationAsync,
  } = useDeleteTotvsIntegrationAsync()
    ;
  const columns: IColumnProps[] = [
    {
      id: 'discriminator',
      label: t('integrationsPage.tableColumns.type'),
      width: '0%',
      align: 'center',
      render: (val: any, rowIndex: number, row?: any) => {
        const icon = renderIconByIntegrationType(val);
        const isActive = row?.isActive ?? true;
        return (
          <MuiBadge
            variant="dot"
            color={isActive ? 'success' : 'error'}
            overlap="circular"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
          >
            {icon}
          </MuiBadge>
        );
      },
    },
    {
      id: 'name',
      label: t('integrationsPage.tableColumns.name'),
      width: '50%',
    },
    {
      id: 'description',
      label: t('integrationsPage.tableColumns.description'),
      width: '100%',
    },
    {
      id: 'id',
      label: t('integrationsPage.tableColumns.actions'),
      align: 'center',
      width: 'min',
      render: (id, rowIndex: number, row?: any) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => {
            const integration = integrations.find(int => int.id === Number(id));
            setSelectedItem(integration);
            setIsVisibleDeleteItemModal(true);
          }}
          handleEdit={() => {
            const integration = integrations.find(int => int.id === Number(id));
            setSelectedItem(integration);
            setIsVisibleEditionModal(true);
          }}
        />
      ),
    },
  ];

  const handleDeleteItem = (id: number) => {
    setSelectedItem(integrations.find((int) => int.id === id));
    setIsVisibleDeleteItemModal(true);
  };

  const handleEdit = (id: number) => {
    setSelectedItem(integrations.find((int) => int.id === id));
    setIsVisibleEditionModal(true);
  };

  const additionalComponent = () => {
    return (
      <ButtonComponent onClick={handleModalEdition}>
        {t('integrationsPage.newIntegration')}
      </ButtonComponent>
    );
  };

  const handleModalEdition = () => {
    setIsVisibleEditionModal(true);
  };

  const renderIconByIntegrationType = (val: IntegrationDiscriminator) => {
    switch (val) {
      case 'CigamEntity':
        return <IconImageComponent src={cigam_icon} />;
      case 'MoniEntity':
        return <IconImageComponent src={moni_icon} />;
      case 'SurgardEntity':
        return <LockReset color="success" />;
      case 'WebhookEntity':
        return <Webhook color="primary" />;
      case 'SigmaEntity':
        return <IconImageComponent src={sigma_icon} />;
      case 'DefenseEntity':
        return <Shield width={3} height={3} />;
      case 'DefenseBridgeEntity':
        return <Route width={3} height={3} />;
      case 'ClassAppEntity':
        return <Route width={3} height={3} />;
      case 'GvdasaEntity':
        return <Route width={3} height={3} />;
      case 'ActiveSoftEntity':
        return <Route width={3} height={3} />;
      case 'TuyaEntity':
        return <IconImageComponent src={tuya_icon} height={15} />;
      case 'TotvsEntity':
        return <IconImageComponent src={totvs_icon} height={12} />;
      case 'SmtpEntity':
        return <Mail />;
      case 'TotvsIENHEntity':
        return <IconImageComponent src={totvs_icon} height={12} />;
    }
    return <></>;
  };

  const handleCancelDeletion = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItem(undefined);
  };

  const handleConfirmDeletion = async () => {
    if (selectedItem?.id) {
      switch (selectedItem.discriminator) {
        case 'SurgardEntity':
          await mutateDeleteSurgardIntegrationAsync(selectedItem?.id);
          break;
        case 'WebhookEntity':
          await mutateDeleteWebhookIntegrationAsync(selectedItem?.id);
          break;
        case 'MoniEntity':
          await mutateDeleteMoniIntegrationAsync(selectedItem?.id);
          break;
        case 'DefenseEntity':
          await mutateDeleteDefenseIntegrationAsync(selectedItem?.id);
          break;
        case 'SigmaEntity':
          await mutateDeleteSigmaIntegrationAsync(selectedItem?.id);
          break;
        case 'DefenseBridgeEntity':
          await mutateDeleteDefenseBridgeIntegrationAsync(selectedItem?.id);
          break;
        case 'ClassAppEntity':
          await mutateDeleteClassAppIntegrationAsync(selectedItem?.id);
          break;
        case 'GvdasaEntity':
          await mutateDeleteGvdasaIntegrationAsync(selectedItem?.id);
          break;
        case 'ActiveSoftEntity':
          await mutateDeleteActiveSoftIntegrationAsync(selectedItem?.id);
          break;
        case 'SmtpEntity':
          await mutateDeleteSmtpIntegrationAsync(selectedItem?.id);
          break;
        case 'ClipEscolaEntity':
          await mutateDeleteClipEscolaIntegrationAsync(selectedItem?.id);
          break;
        case 'SophiaEntity':
          await mutateDeleteSophiaIntegrationAsync(selectedItem?.id);
          break;
        case 'CigamEntity':
          await mutateDeleteCigamIntegrationAsync(selectedItem?.id);
          break;
        case 'TuyaEntity':
          await mutateDeleteTuyaIntegrationAsync(selectedItem?.id);
          break;
        case 'TotvsEntity':
          await mutateDeleteTotvsIntegrationAsync(selectedItem?.id);
          break;
        case 'TotvsIENHEntity':
          await mutateDeleteTotvsIENHIntegrationAsync(selectedItem?.id);
          break;
      }
    }
    resetAll();
    showSnackbar('Integração excluída com sucesso.', 'success');
    reqAllIntegrations();
  };

  const reqAllIntegrations = () =>
    mutateGetAllIntegrationsByLicenseAsync().then(setIntegrations);

  const handleCloseEdition = () => {
    resetAll();
    reqAllIntegrations();
  };

  const resetAll = () => {
    setSelectedItem(undefined);
    setIsVisibleEditionModal(false);
    setIsVisibleDeleteItemModal(false);
    setIntegrationEditModalKey(Math.random() * 20);
  };

  useEffect(() => {
    reqAllIntegrations();
  }, []);
  return (
    <>
      <HeaderDashboard></HeaderDashboard>
      <TableComponent
        rows={integrations}
        sortByName={'name'}
        additionalTitleComponent={additionalComponent()}
        columns={columns}
        defaultOrder={'asc'}
        title={t('integrationsPage.title')}
      />

      <IntegrationEditModal
        key={integrationEditModalKey}
        isOpen={isVisibleEditionModal}
        renderIconByIntegrationType={renderIconByIntegrationType}
        handleClose={handleCloseEdition}
        integrationSelected={selectedItem}
      />

      <ConfirmDeleteModalComponent
        isLoading={
          isLoadingDeleteMoniIntegrationAsync ||
          isLoadingDeleteWebhookIntegrationAsync ||
          isLoadingDeleteDefenseIntegrationAsync ||
          isLoadingDeleteSigmaIntegrationAsync ||
          isLoadingDeleteSurgardIntegrationAsync ||
          isLoadingDeleteDefenseBridgeIntegrationAsync ||
          isLoadingDeleteClipEscolaIntegrationAsync ||
          isLoadingDeleteCigamIntegrationAsync ||
          isLoadingDeleteSophiaIntegrationAsync ||
          isLoadingDeleteSmtpIntegrationAsync ||
          isLoadingDeleteActiveSoftIntegrationAsync ||
          isLoadingDeleteGvdasaIntegrationAsync ||
          isLoadingDeleteClassAppIntegrationAsync ||
          isLoadingDeleteTuyaIntegrationAsync ||
          isLoadingDeleteTotvsIntegrationAsync||
          isLoadingDeleteSigmaIntegrationAsync ||
          isLoadingDeleteTotvsIENHIntegrationAsync
        }
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir Integração'}
        message={`Tem certeza que deseja excluir a integração "${selectedItem?.name}"?`}
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
      />
    </>
  );
}

export default IntegrationPage;
